'use client';

import React from 'react';
import Link from 'next/link';

const Footer = () => {
  const navLinks = [
    { label: 'Home', href: '/' },
    { label: 'Our Mission', href: '/our-mission' },
    { label: 'Universities — Spain', href: '/universities-spain' },
    { label: 'Universities — Portugal', href: '/universities-portugal' },
    { label: 'Visa & Immigration', href: '/visa-immigration' },
    { label: 'Workforce Solutions', href: '/workforce-solutions' },
    { label: 'Contact Us', href: '/contact' },
  ];

  return (
    <footer style={{ backgroundColor: '#1a2e3b' }} className="text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <h3 className="font-headline font-bold text-white text-xl mb-1" style={{ letterSpacing: '-0.01em' }}>
                NEXUS VANTAGE
              </h3>
              <p className="font-body text-white/70 text-xs uppercase tracking-widest">
                Education &amp; Immigration Consultancy
              </p>
            </div>
            <p className="font-body text-white/60 text-sm leading-relaxed mb-6">
              Your dedicated education and immigration consultancy for studying in Spain and Portugal. Guiding students from India and the GCC every step of the way.
            </p>
            {/* LinkedIn */}
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors duration-200"
              aria-label="Nexus Vantage on LinkedIn"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                <rect x="2" y="9" width="4" height="12"/>
                <circle cx="4" cy="4" r="2"/>
              </svg>
              <span className="text-sm font-body">LinkedIn</span>
            </a>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-body font-semibold text-white text-sm uppercase tracking-widest mb-6">Navigation</h4>
            <ul className="space-y-3">
              {navLinks?.map((link) => (
                <li key={link?.href}>
                  <Link
                    href={link?.href}
                    className="font-body text-white/60 hover:text-white text-sm transition-colors duration-200"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body font-semibold text-white text-sm uppercase tracking-widest mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <svg className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: '#2A7FA5' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:contact@nexusvantage.eu" className="font-body text-white/60 hover:text-white text-sm transition-colors duration-200">
                  contact@nexusvantage.eu
                </a>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: '#2A7FA5' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9" />
                </svg>
                <a href="https://nexusvantage.eu" className="font-body text-white/60 hover:text-white text-sm transition-colors duration-200">
                  nexusvantage.eu
                </a>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: '#2A7FA5' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="font-body text-white/60 text-sm">
                  Based in Lisbon, Portugal<br />
                  <span className="text-white/40">Serving Students from India &amp; the GCC</span>
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-white/40 text-sm">
            © 2025 Nexus Vantage. All rights reserved.
          </p>
          <p className="font-body text-white/40 text-sm">
            "Your European Journey Begins Here"
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
